import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lbn-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class LbnFooterComponent {
  /** `app` = main shell; `auth` = login/register; `inline` = minimal padding */
  @Input() variant: 'app' | 'auth' | 'inline' = 'app';
}

@NgModule({
  declarations: [LbnFooterComponent],
  imports: [CommonModule],
  exports: [LbnFooterComponent]
})
export class LbnFooterModule { }
